export type CrmCustomer = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  company: string;
  address: string;
  notes: string;
  purchase_count?: number;
  nps_score?: number | null;
  last_purchase_at?: string | null;
};

export type CrmOffer = {
  id: string;
  customer_id: string;
  title: string;
  description: string;
  offer_type: string;
  status: string;
  valid_until: string | null;
};

export const OFFER_TYPE_CONFIG: Record<
  string,
  { label: string; tone: 'indigo' | 'amber' | 'emerald' }
> = {
  nouveau_produit: { label: 'Nouveau produit', tone: 'indigo' },
  promotion: { label: 'Promotion', tone: 'amber' },
  remise: { label: 'Remise', tone: 'emerald' },
};

export const OFFER_STATUS_LABELS: Record<string, string> = {
  envoye: 'Envoyé',
  en_attente: 'En attente',
  accepte: 'Accepté',
  refuse: 'Refusé',
};

export const OFFER_STATUS_OPTIONS = [
  { value: 'envoye', label: 'Envoyé' },
  { value: 'en_attente', label: 'En attente' },
  { value: 'accepte', label: 'Accepté' },
  { value: 'refuse', label: 'Refusé' },
] as const;

export type OfferStatus = (typeof OFFER_STATUS_OPTIONS)[number]['value'];
